"use client";
import { CSSProperties } from "react";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
import { getBaseUrl } from "@/util/get-base-url";

interface HorizontalShortcutItemComponentProps {
    item: any;
}

const  HorizontalShortcutItemComponent = ({ item }: HorizontalShortcutItemComponentProps) => {
    const actionFunc = {
        OPEN_LINK_URL: "OPEN_LINK_URL",
        OPEN_POPUP_REFERRAL: "OPEN_POPUP_REFERRAL",
    }
    const colorStyle = useContext(ColorStyleContext);


    const generateItem = () => {
        return (
            <div className="flex flex-col justify-start items-center flex-shrink-0 gap-2 first:ml-auto last:mr-auto"
                style={{ color: colorStyle?.text || "#3d3d3d" }}>
                {item.image && 
                    <picture>
                        <source
                            srcSet={`${getBaseUrl(item.image)}_resize.avif`}
                            type="image/avif"
                        />
                        <source
                            srcSet={`${getBaseUrl(item.image)}_resize.webp`}
                            type="image/webp"
                        />
                        <img
                            src={item.image}
                            alt={item.imageAlt}
                            width={60}
                            height={60}
                            loading="lazy"
                        />
                    </picture>
                }
                <div className="flex flex-col">
                    {item.title && (
                        <div className="text-center">
                            <h5 className="line-clamp-2">{item.title}</h5>
                        </div>
                    )}
                    {item.desc && (
                        <div className="text-center">
                            <p className="font-light line-clamp-2">{item.desc}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    if (item.actionFunc === actionFunc.OPEN_LINK_URL || item.actionFunc === actionFunc.OPEN_POPUP_REFERRAL) {
        return (
            <a href={item.href} target="_self">
                {generateItem()}
            </a>
        );
    }

    return <div>{generateItem()}</div>;
};

export default HorizontalShortcutItemComponent;
